var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailAdd = function SvgEmailAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 8v12H0V8h18zM2 10v8h14v-8H2zm0 0v1.6l7 3.5 7-3.5V10l-7 3.4L2 10zm19-5V2h-2v3h-3v2h3v3h2V7h3V5h-3z"
  })));
};
export default SvgEmailAdd;